import React, {useState} from 'react';
import 'fontsource-roboto';
import {makeStyles} from '@material-ui/core/styles';
import useIsMountedRef from './../Components/useIsMountedRef';
import Container from '@material-ui/core/Container';
import CardMedia from '@material-ui/core/CardMedia';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  divider: {
    margin: theme.spacing(.5, 0)
  },
  cardMedia: {
    height: '0px'
  },
  link: {
    textDecoration: 'initial',
    color: 'inherit',
    '&:active': {
      color: 'inherit'
    }
  }
}));

export default function Login(props) {
  const classes = useStyles();
  const ajax = props.ajax;

  const isMountedRef = useIsMountedRef();

  const [data, setData] = useState({
    username: '',
    password: ''
  });

  const handleDataChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter')
      submitData();
  };

  const submitData = async () => {
    ajax('login', data)
      .then(response => {
        if (!isMountedRef.current) return;

        if (Boolean(response.ok)) {
          localStorage.setObject('user', response.data);
          props.setUser(response.data);
        } else {
          localStorage.removeItem('user');
        }
      });
  };

  return (
    <Container maxWidth='xs'>
      <CardMedia image='/logo.jpg' className={classes.cardMedia} style={{marginTop: '16px', paddingTop: `${394 / 1280 * 100}%`}} />
      <TextField variant='outlined' margin='normal' required inputProps={{maxLength: 64}} disabled={props.isLoading}
        name='username'
        label='Nume de utilizator'
        data={data.username}
        onKeyPress={handleKeyPress}
        onChange={handleDataChange}
      />
      <TextField variant='outlined' margin='normal' required type='password' disabled={props.isLoading}
        name='password'
        label='Parola'
        data={data.password}
        onKeyPress={handleKeyPress}
        onChange={handleDataChange}
      />
      <Button fullWidth variant='contained' color='primary' disabled={props.isLoading}
        onClick={submitData}
      >
        Autentificare
      </Button>
    </Container>
  );
}